import { ShipmentsTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  milestoneEventSH: [],
  milestoneBySelectedItem: [],
  listHouses: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const shipments = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ShipmentsTypes.GET_SHIPMENTS:
      return {
        ...state,
        isLoading: true,
      };
    case ShipmentsTypes.GET_SHIPMENTS_SUCCESS:
      return {
        ...state,
        data: action.payload.shipmentsData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case ShipmentsTypes.GET_SHIPMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ShipmentsTypes.GET_MILESTONESCONFIG_SH_SUCCESSS:
      return {
        ...state,
        milestoneConfig: action.payload
      }

    case ShipmentsTypes.GET_MILESTONESCONFIG_SH_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH:
      return {
        ...state,
        isLoading: true,
      }
    case ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH_SUCCESSS:
      return {
        ...state,
        milestoneEventSH: action.payload,
        isLoading: false,
      }
    case ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    case ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH:
      return {
        ...state,
        // isLoading: true,
      }
    case ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH_SUCCESSS:
      return {
        ...state,
        milestoneBySelectedItem: action.payload,
        // isLoading: false,
      }
    case ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH_FAIL:
      return {
        ...state,
        error: action.payload,
        // isLoading: false,
      }
    case ShipmentsTypes.GET_SHIPMENTS_HOUSES:
      return {
        ...state,
        isLoading: true,
      };
    case ShipmentsTypes.GET_SHIPMENTS_HOUSES_SUCCESS:
      return { 
        ...state,
        listHouses: action.payload.listData,
        isLoading: false,
      };
    case ShipmentsTypes.GET_SHIPMENTS_HOUSES_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default shipments;
